module.exports = __webpack_public_path__ + "img/鼎锐联组态软件.14aa2989.png";